import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

export const useEditableTableStyles = makeStyles((theme: Theme) =>
    createStyles({
        tableContainer: {
            overflowY: "auto",
            "& .MuiOutlinedInput-input": {
                ...theme.typography.caption,
            },
        },
        table: {
            border: `1px solid ${theme.palette.grey[300]}`,
            "& .MuiTableBody-root .MuiTableRow-root:nth-child(odd)": {
                backgroundColor: theme.palette.grey[50],
            },
            "& .MuiTableCell-root": {
                border: `1px solid ${theme.palette.grey[300]}`,
                padding: theme.spacing(1),
                ...theme.typography.caption,
            },
            "& .MuiTableCell-head": {
                color: "inherit",
                ...theme.typography.caption,
                fontWeight: 500,
            },
        },
    })
);

export const useEditableTableReconcileStyles = makeStyles((theme: Theme) =>
    createStyles({
        errorContainer: {
            color: "red",
            textAlign: "center",
            margin: "0 0 10px 0",
        },
        tableContainer: {
            maxHeight: "450px",
            overflowY: "auto", // "scroll",
            "& .MuiOutlinedInput-input": {
                ...theme.typography.caption,
                fontWeight: 500,
                color: theme.palette.primary.main,
            },
        },
        table: {
            border: `1px solid ${theme.palette.grey[300]}`,
            "& .MuiTableBody-root .MuiTableRow-root:nth-child(odd)": {
                backgroundColor: theme.palette.grey[50],
            },
            "& .MuiTableCell-root": {
                border: `1px solid ${theme.palette.grey[300]}`,
                padding: theme.spacing(1),
                ...theme.typography.caption,
            },
            "& .MuiTableCell-head": {
                ...theme.typography.caption,
                fontWeight: "bold",
            },
        },

        emptyCell: {
            backgroundColor: theme.palette.common.white,
            height: "350px",
            textAlign: "center",
        },
        btnChooseProduct: {
            minWidth: "170px",
        },
    })
);
